"use client";

import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Safely extract message as string only - never render error object directly
  const message: string =
    error instanceof Error ? error.message : String(error ?? "Unknown error");

  useEffect(() => {
    // Log on client only; keeps SSR/prerender safe
    console.error("[ErrorPage]", message);
  }, [message]);

  return (
    <main
      style={{
        padding: 24,
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      }}
    >
      <h1 style={{ fontSize: 24, margin: 0 }}>Something went wrong</h1>
      <p style={{ marginTop: 12 }}>
        Please try again. If this keeps happening, contact support.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        style={{
          marginTop: 12,
          padding: "10px 14px",
          borderRadius: 8,
          border: "1px solid #ccc",
          background: "transparent",
          cursor: "pointer",
        }}
      >
        Retry
      </button>
    </main>
  );
}
